import { gql } from "@apollo/client"
import { RESPONSE_SET_FIELDS } from "@data/processes/fragments/responseSetFragment"

const MULTIPLE_CHOICE_JOB_STEP_FIELDS = gql`
  fragment MultipleChoiceJobStepFields on MultipleChoiceJobStep {
    id
    step
    number
    section
    name
    score
    possibleScore
    failed
    description
    responseType
    responseMandatory
    responseSet {
      ...ResponseSetFields
    }
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    logic {
      range
      textValues
      outcomes {
        type
        steps
      }
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
  ${RESPONSE_SET_FIELDS}
`

export { MULTIPLE_CHOICE_JOB_STEP_FIELDS }
